import styled from 'styled-components';
import { Page } from '../../components/Page/Page';
import { palette } from '../../theme/colors';

export const SPage = styled(Page)`
  padding: 0rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 4.81rem is the header height */
  height: calc(100vh - 4.81rem);
`;

export const STitle = styled.h1`
  font-family: 'Roboto-Regular';
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.45em;
  margin-bottom: 0.5rem;
  color: ${palette.white};
`;

export const SDescription = styled.p`
  font-family: 'Roboto-Regular';
  font-weight: 400;
  font-size: 0.875rem;
  text-align: center;
  line-height: 1.45em;
  margin-bottom: 1.5rem;
  color: ${palette.gainsBoro2};
`;

export const SLoginLink = styled.a`
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  height: 2.812rem;
  border-radius: 1.562rem;
  background-color: ${palette.honeyYellow};
  color: ${palette.navyBlue};
  font-family: 'Roboto-Regular';
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
`;
